<template>
  <v-container class="general-overview-container standard-content-container">
    <v-row no-gutters>
      <v-col cols="12" md="5">
        <v-row no-gutters class="title-section">
          <v-col
            cols="12"
            sm="2"
            class="link-container"
            :class="{
              'small-container':
                this.$vuetify.breakpoint.width <=
                this.$vuetify.breakpoint.thresholds.xs,
            }"
          >
            <router-link :to="{ name: 'OverviewPage' }" class="back-arrow"
              ><v-icon large color="mid-grey" class="mt-1">{{
                icons.mdiArrowLeft
              }}</v-icon></router-link
            >
          </v-col>
          <v-col cols="12" sm="10" class="standard-title-container">
            <h1 class="">Old Mutual Will Collection Booking Form</h1>
            <h3>Book your will collection service</h3>
            <p class="your-people-description">
              Schedule a convenient time for our courier service to collect your
              completed will. We'll ensure safe and secure transportation to our
              secure storage facility.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="7">
        <div class="left-section-container">
          <div v-if="$apollo.loading" class="text-center">
            <v-progress-circular indeterminate color="primary" />
            <p>Loading testator information...</p>
          </div>
          <div v-else-if="testator">
            <WillCollectionBookingForm
              @booking-success="handleBookingSuccess"
              @close="handleClose"
              :testator="testator"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import WillCollectionBookingForm from './WillCollectionBookingForm.vue';
  import { TESTATOR_QUERY } from '../../../constants/graphql/testators';

  export default {
    name: 'WillCollectionBooking',
    components: { WillCollectionBookingForm },
    data() {
      return {
        loading: false,
        testator: null,
      };
    },
    computed: {
      testatorId() {
        return this.$route.query.testatorId;
      },
    },
    methods: {
      handleClose() {
        this.$router.push({ name: 'OverviewPage' });
      },
      handleBookingSuccess() {
        this.$router.push({ name: 'OverviewPage' });
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        skip() {
          return !this.testatorId;
        },
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
        result(response) {
          if (response.data && response.data.testator) {
            this.loading = false;
          }
        },
        error(error) {
          console.error('Error fetching testator:', error);
          this.loading = false;
        },
      },
    },
  };
</script>

<style scoped lang="scss">
  .general-overview-container {
    text-align: left;
    padding-top: 40px;

    h3 {
      font-size: 24px;
      font-weight: 600;
      line-height: 31.2px;
      margin-bottom: 30px;
    }

    .your-people-description {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: var(--v-font-color-base);
      margin-bottom: 30px;
    }
  }
</style>
